import PropTypes from 'prop-types';
import { projectListShell } from '../../../styles/projectListShell';

/**
 * Project selection list.
 * Card chrome: projectListShell (compact on iPad; title scales at bp-lg / bp-2xl).
 */
const ProjectCardIcon = ({ imageUrl, imageAlt }) => {
    if (imageUrl) {
        return (
            <img
                src={imageUrl}
                alt={imageAlt || "プロジェクトアイコン"}
                className="size-full rounded-lg object-cover"
            />
        );
    }

    return (
        <svg
            className={projectListShell.iconSvg}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <path
                d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
                fill="currentColor"
            />
        </svg>
    );
};

const ProjectList = ({ projects, onProjectClick }) => {
    if (!projects || projects.length === 0) {
        return null;
    }

    const handleProjectClick = (project) => {
        if (onProjectClick && typeof onProjectClick === 'function') {
            onProjectClick(project);
        }
    };

    const handleKeyDown = (event, project) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleProjectClick(project);
        }
    };

    return (
        <section
            className={projectListShell.section}
            aria-label="プロジェクト一覧"
        >
            {projects.map((project) => (
                <article
                    key={project.id}
                    className={projectListShell.card}
                    onClick={() => handleProjectClick(project)}
                    onKeyDown={(e) => handleKeyDown(e, project)}
                    tabIndex={0}
                    role="button"
                    aria-label={`プロジェクト「${project.name}」を選択`}
                    aria-describedby={`project-${project.id}-description`}
                >
                    <div className={projectListShell.cardInner}>
                        <div
                            className={projectListShell.iconBox}
                            aria-hidden="true"
                        >
                            <ProjectCardIcon
                                imageUrl={project.imageUrl}
                                imageAlt={project.imageAlt || `${project.name}のアイコン`}
                            />
                        </div>
                        <div className={projectListShell.titleWrap}>
                            <h3
                                className={projectListShell.title}
                                id={`project-${project.id}-description`}
                            >
                                {project.name}
                            </h3>
                        </div>
                    </div>
                </article>
            ))}
        </section>
    );
};

ProjectList.propTypes = {
    projects: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name: PropTypes.string.isRequired,
            imageUrl: PropTypes.string,
            imageAlt: PropTypes.string,
        })
    ).isRequired,
    onProjectClick: PropTypes.func.isRequired,
};

ProjectCardIcon.propTypes = {
    imageUrl: PropTypes.string,
    imageAlt: PropTypes.string,
};

export default ProjectList;
